import React from "react"
import Icon from "../_icon"

const IconDefault = (props) => {
  return (
    <div>
      <Icon
          fixedWidth 
          icon="user"
          {...props}
      />
    </div>
  )
}

export default IconDefault
